module.exports = __webpack_public_path__ + "static/media/paymentpage_amount.6b5f832b.png";